<p-avatar v-if="total_notif > 0"
    :icon="is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-bell'" 
    shape="circle" 
    type="button" 
    aria-haspopup="true"
    aria-controls="overlay_menu"
    style="background-color: #2196f3; color: #ffffff"
    v-badge.danger="total_notif"
    @click="toggle" 
/>

<p-avatar v-else
    :icon="is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-bell'" 
    shape="circle" 
    type="button" 
    aria-haspopup="true"
    aria-controls="overlay_menu"
    style="background-color: #2196f3; color: #ffffff"
    @click="toggle" 
/>


<!----------------------------------------------------------------------------------->
<p-menu class="md:w-15rem" ref="menu" id="overlay_menu" :model="items"  :popup="true" >
    <!------------------------------------------------------------>
    <template #start>
        <div class="grid mt-1">
            <div class="col text-left ml-3">
                <b>Notification</b>
            </div>
            <div class="col text-right mr-3">
                <p-avatar
                    :icon="is_loading ? 'pi pi-spin pi-spinner' : 'pi pi-sync'" 
                    shape="circle" 
                    type="button" 
                    @click="refresh" 
                />
            </div>
        </div>
    </template>
    <!------------------------------------------------------------>
    <!------------------------------------------------------------>
    <template #item="{ item, props }">
        <router-link :to="item.to ?  item.to : ''" v-ripple class="flex align-items-center" v-bind="props.action" >
            <font-awesome-icon :icon="item.icon" />
            <span class="ml-2">{{ item.label }}</span>
            <p-badge v-if="item.total" severity="warning" class="ml-auto" :value="item.total" />
        </router-link>
    </template>
    <!------------------------------------------------------------>
</p-menu>
<!----------------------------------------------------------------------------------->
